var map = {
	"./account-ico-mail.svg": 811,
	"./account-ico-pass.svg": 812,
	"./account-ico-phone.svg": 813,
	"./bank-transfer.svg": 814,
	"./betnearn-ico.svg": 815,
	"./birthday-bonus-ico.svg": 816,
	"./birthday.webp": 1906,
	"./bonus-code-ico.svg": 817,
	"./bonus-ico.svg": 818,
	"./bonus-received-ico.svg": 819,
	"./bonus.webp": 1907,
	"./business-account-upgrade-ico.svg": 820,
	"./check-in-daily-ico.svg": 821,
	"./checked.svg": 822,
	"./cloud-pointer.svg": 823,
	"./crypto.svg": 824,
	"./daily-bonus-ico.svg": 825,
	"./daily-limit.webp": 1908,
	"./deposit-delay-bonus-ico.svg": 826,
	"./e-wallet.svg": 827,
	"./earn-coin-ico.svg": 828,
	"./earn-x33-coin-ico.svg": 829,
	"./email.svg": 830,
	"./facebook.svg": 831,
	"./feedback.svg": 832,
	"./first-bet-ico.svg": 833,
	"./games-rebate-ico.svg": 834,
	"./info.svg": 835,
	"./instagram.svg": 836,
	"./instant-rebate.svg": 837,
	"./live-casino-rebate-ico.svg": 838,
	"./lucky-spin-ico.svg": 839,
	"./messenger.svg": 840,
	"./mobile-app-deposit-ico.svg": 841,
	"./monthly-cash.webp": 1909,
	"./msg-activity.svg": 842,
	"./msg-ann.svg": 843,
	"./msg-notice.svg": 844,
	"./new-icon.svg": 845,
	"./people-ico.svg": 846,
	"./quick-pay.svg": 847,
	"./r77-coin.svg": 848,
	"./rescue-bonus-ico.svg": 849,
	"./rescue-lc-ico.svg": 850,
	"./rescue-slots-ico.svg": 851,
	"./return.svg": 852,
	"./sc-bc-active-ico.svg": 853,
	"./sc-bc-ico.svg": 854,
	"./sc-bi-active-ico.svg": 855,
	"./sc-bi-ico.svg": 856,
	"./sc-mail-active-ico.svg": 857,
	"./sc-mail-ico.svg": 858,
	"./sc-mp-active-ico.svg": 859,
	"./sc-mp-ico.svg": 860,
	"./sc-pin-active-ico.svg": 861,
	"./sc-pin-ico.svg": 862,
	"./slots-rebate-ico.svg": 863,
	"./sports-rebate-ico.svg": 864,
	"./telegram.svg": 865,
	"./twitter.svg": 866,
	"./vip-up-level-ico.svg": 867,
	"./vip-weekly-bonus.svg": 868,
	"./wallet-ico.svg": 869,
	"./weekly-tournament-ico.svg": 870,
	"./welcome-bonus-ico.svg": 871,
	"./whatsapp.svg": 872,
	"./withdrawal-delay-bonus-ico.svg": 873,
	"./withdrawal.webp": 1910,
	"./x33-coin.svg": 874
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 478;